<template>
  <div>
    <disqualification-template ref="template" :orderStatus="3" type="report"/>
    <vxe-loading v-model="loading"/>
  </div>
</template>

<script>
import DisqualificationTemplate from '@/views/quality/disqualification/DisqualificationTemplate.vue'

export default {
  name: 'DisqualificationDestroyApply',
  components: { DisqualificationTemplate },
  data() {
    return {
      loading: false
    }
  },
  methods: {}
}
</script>